import {match} from 'ts-pattern';

import {isNotNil} from 'ramda-adjunct';

import {ChartHighlightEncodingStyle} from '../types/ChartHighlightEncodingStyle';
import {ChartVariant} from '../types/ChartVariant';

export function getChartHighlightEncodingStyle(
  chartVariant: ChartVariant
): ChartHighlightEncodingStyle | null {
  return match(chartVariant)
    .with('priceMap', () => 'scatter' as const)
    .with('price', 'mileage', 'daysOnStock', 'featuresLevel', () => 'bar' as const)
    .otherwise(() => null);
}

export function supportsChartToolbarHighlights(chartVariant: ChartVariant) {
  return isNotNil(getChartHighlightEncodingStyle(chartVariant));
}
